export default __webpack_public_path__ + "static/media/property-safety.39f57be3.svg";